import script from "./addPlate.vue?vue&type=script&setup=true&lang=js"
export * from "./addPlate.vue?vue&type=script&setup=true&lang=js"

import "./addPlate.vue?vue&type=style&index=0&id=3dedeeeb&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dedeeeb"]])

export default __exports__